import { useQuery } from "@tanstack/react-query";

import { WORKSPACE_KEY } from "./keys";

import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getWorkspaceMock } from "@/mock/handlers/workspace";
import { Response } from "@/types/pagination";
import { Workspace } from "@/types/workspace";

import { api } from "@/lib/api-client";

export const WORKSPACE_CONFIG_CACHE_KEY = (workspaceId: string) => [
  ...WORKSPACE_KEY,
  workspaceId,
];

export const useGetWorkspace = (workspaceId: string | null) => {
  return useQuery({
    queryKey: WORKSPACE_CONFIG_CACHE_KEY(workspaceId!),
    enabled: !!workspaceId,
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();
        return getWorkspaceMock(workspaceId!);
      }

      const { data } = await api
        .get(`workspaces/${workspaceId}`)
        .json<Response<Workspace>>();

      return data;
    },
    retry: 2,
  });
};
